import React, {useState, createRef, useEffect}  from 'react'
import { useHistory, useLocation } from "react-router-dom"
import emitter from "@/util/ev"
import '@/assets/css/head.scss'
import closeImg from '@/assets/img/icon/close.png'
import intl from 'react-intl-universal';
import {langPath} from "@/util";
import {REQUEST} from "@/api";


const CATE_TYPE = {
    type1: 3, // 原创系列
    type2: 2 // 经典系列
}
const Head = () => {
    const [showMenu, setShowMenu] = useState(false)
    const [showShare, setShowShare] = useState(false)
    const [showSearch, setSearch] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [shareInfo, setShareInfo] = useState({})
    const [menu, setMenu] = useState({})
    const [menuType, setMenuType] = useState('menu')
    const [isHome, setIsHome] = useState(true)

    const inputRef1 = createRef();
    const history = useHistory();
    const location = useLocation();

    // 切换导航
    const changeNav = (item) => {
        if (!!item.type) {
            setMenuType(item.type)
            return
        }
        setShowMenu(false)
        setSearch(false)
        goPage(item.path)
    }
    const goDetailPage = (item, type) => {
        if (item.padding) return
        const PATH = {
            des: '/dec/' + item.id,
            style: `/goods?c=${item.id}&t=s`,
            classic: `/goods?c=${item.id}&t=c`,
        }
       goPage(PATH[type])

    }
    const goPage = (path) => {
        history.push(langPath(path))
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.location.reload()
    }
    // 返回上一页
    const goBack = (type) => {
        if (type === 'menu') {
            history.push(langPath('/'))
            setShowMenu(false)
            setSearch(false)
        } else {
            setMenuType('menu')
        }
    }
    // 设置搜索内容
    const searchGoods = (e) => {
        setSearchValue(inputRef1.current.value)
    }
    // 搜索跳转页面
    const handleSubmit = (e) => {
        setShowMenu(false)
        setSearch(false)
        if (!inputRef1.current.value) return;
        let url = '/search?w=' + encodeURIComponent(inputRef1.current.value)
        history.push(langPath(url))
        window.location.reload()
    }
    // 获取分类
    const fetchCategorys = (type, pid) => {
        const data = {
            type,
            pid,
            shelves: '1'
        }
        return REQUEST('category', data).then((res) => {
            return res.body
        })
    }

    useEffect(() => {
        setIsHome(location.pathname !== '/')
    }, [location])
    useEffect(() => {
        const initShareInfo = {
            wx: {
                img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/vip/wx.jpg',
                text: intl.get('info').wx
            },
            wb: {
                img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/vip/wb.jpg',
                text: intl.get('info').wx
            },
            tel: {
                tel: '400-820-0231',
                text: intl.get('info').tel
            }
        }
        emitter.addListener('callMe', (type) => {
            setShareInfo(initShareInfo[type])
            setShowShare(true)
        })
    }, [])
    useEffect(() => {
        async function fetchData() {
            // You can await here
            const type = intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
            const desCategories = await fetchCategorys(type, CATE_TYPE.type1)
            const classicCategories = await fetchCategorys(type, CATE_TYPE.type2)
            const [classic1, classic2] = classicCategories
            const len = classic1.child.length - classic2.child.length
            const child = len < 0 ? classic1.child : classic2.child
            // eslint-disable-next-line no-unused-vars
            for (let v of (new Array(Math.abs(len)))) {
                child.push({
                    padding: 1,
                    id: Math.random()
                })
            }
            setMenu(Object.assign({}, {desCategories, classicCategories, roitlilyData: intl.get('lv2Navs')}))
        }
        fetchData().then()
    }, [])
    return (
        <header className={['header ', isHome ? ' border-bt ' : '']}>
            {
                // showShare || showMenu ? '' : (<i className="line" />)
            }
            <div className="nav-box flex-between">
                <div className="nav-left">
                    <div className="logo flex-center" onClick={() => {history.replace(langPath('/'))}}>
                        <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/logo.png" alt=""/>
                    </div>
                </div>
                <div className={['nav-right ', showShare || showMenu ? '' : ' linel ']}>
                    { showShare || showMenu ?
                        (<div className="item close flex-center" onClick={() => {setShowMenu(false);setShowShare(false); setMenuType('menu')}}>
                            <div className="img-box">
                                <img src={closeImg} alt=""/>
                            </div>
                        </div>)
                        :
                        (<div className="item menu show flex-column-start-bwt">
                            <p onClick={() => {setShowMenu(true); setSearch(false)}}>MENU</p>
                            <p onClick={() => {setSearch(true)}}>SEARCH</p>
                        </div>)
                    }


                </div>
            </div>
            {/* 具体内容 */}
            <div className="nav-content">
                {
                    showSearch
                    ?
                        (<div className="search-box flex-between-end">
                            <div className="search-input">
                                <form onSubmit={() => handleSubmit()}>
                                <input
                                    ref={inputRef1}
                                    type="search"
                                    autoComplete="off"
                                    autoFocus={true}
                                    onInput={(event) => searchGoods(event)}
                                    placeholder={intl.get('other').search} />
                                </form>
                            </div>
                            <div className="search-close">
                                <img onClick={() => {setSearch(false)}} src={closeImg} alt=""/>
                            </div>
                        </div>)
                        : ''
                }
                {
                    showMenu &&
                    (<div className="nav-item2 flex-column">
                        {
                            menuType === 'menu' &&
                            (
                                <div className="nav-list">
                                    {intl.get('navs').map(val => {
                                        return (
                                            <div className="nav-item" key={val.name} onClick={() => {changeNav(val)}}>
                                                {val.name}
                                            </div>
                                        )
                                    })}
                                </div>
                            )

                        }
                        {
                            menuType === 'des' &&
                            (
                                <div className="nav-list detail desc">
                                    <div className="nav-item title">
                                        {
                                            intl.getInitOptions().currentLocale === 'zh-CN' ? '原创设计' : 'ORIGINAL DESIGN'
                                        }
                                    </div>
                                    {
                                        menu.desCategories && menu.desCategories.map(val => {
                                             return (
                                                 <div key={val.id}
                                                      className="nav-item"
                                                      onClick={() => goDetailPage(val, 'des')}
                                                 >{val.name}</div>
                                             )
                                        })
                                    }
                                </div>
                            )

                        }
                        {
                            menuType === 'riotlily' &&
                            (
                                <div className="nav-list detail desc">
                                    {
                                        menu.roitlilyData.map(val => {
                                            return (
                                                <div className="nav-item title"
                                                     key={val.name}
                                                     onClick={() => changeNav(val)}
                                                >{val.name}</div>
                                            )
                                        })
                                    }
                                </div>
                            )

                        }
                        {
                            menuType === 'classic' &&
                            (
                                <div className="nav-list detail classic flex-between-top">
                                    {
                                        menu.classicCategories && menu.classicCategories.map(va => {
                                            return (
                                                <div className={['classic-item ', va.id == 4 ? ' classic' : ' style']} key={va.id}>
                                                    <div className="nav-item title">{va.name}</div>
                                                    {
                                                        va.child.map(val => {
                                                            return (
                                                                <div className="nav-item"
                                                                     key={val.id}
                                                                     onClick={() => goDetailPage(val, va.id == 4 ? 'classic' : 'style')}
                                                                >{val.name}</div>
                                                            )
                                                        })
                                                    }

                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        }

                        <div className="nav-btn flex-center" onClick={() => {goBack(menuType)}} >
                            {menuType === 'menu' ? intl.get('footer').home : intl.get('footer').back}
                        </div>
                    </div>)

                    }
                {/* 图片 */}
                {
                    showShare &&
                    (
                        <div className="nav-item2 flex-column">
                            <div className="share-img flex-center">
                                {
                                    shareInfo.img ?
                                        ( <img src={shareInfo.img} alt=""/>)
                                        :
                                        (<p className="f-40">{shareInfo.tel}</p>)
                                }
                            </div>
                            <div className="share-text">
                                {shareInfo.text}
                            </div>
                        </div>
                    )
                }


            </div>
        </header>
    )
}
export default Head
